module.exports = __webpack_public_path__ + "img/Syg_icon_tewtsdf.c8cf9eab.png";